<eau-alert-page
    [title]="getTitle() | translate"
    [text]="getText() | translate: getTextInterpolateParams()"
    [iconType]="getIconType()">
</eau-alert-page>
